<template>
  <div>
    <vxe-grid
      size="mini"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 60px; height: 60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel label="SKU" :value="row.evgSkuNo" />
      </template>
      <template v-slot:displaySpecColor="{ row }">
        <TableLabel :value="row.goodsSize" />
        <TableLabel
          :value="`${row.goodsColor || ''} ${row.goodsColorEn || ''} `"
        />
        <TableLabel :value="row.goodsPattern" />
      </template>
      <template v-slot:displayNo="{ row }">
        <TableLabel
          label="UPC"
          labelKey="table_label_channelEanNo"
          :value="row.channelEanNo"
        />
        <TableLabel
          label="ITEM"
          labelKey="table_label_channelItemNo"
          :value="row.channelItemNo"
        />
        <TableLabel label="NC" labelKey="table_label_ncNo" :value="row.ncNo" />
      </template>
      <template v-slot:displayUnit="{ row }">
        <TableLabel
          label="单位"
          labelKey="table_label_skuPackSize"
          :value="row.v_skuPackSize"
        />
        <TableLabel
          label="入数"
          labelKey="table_label_specInUnitQty"
          :value="row.specInUnitQty"
        />
      </template>
      <template v-slot:displayCarton="{ row }">
        <TableLabel :value="row.v_cartonType" />
        <TableLabel
          label="入数"
          labelKey="table_label_unitInCtnQty"
          :value="row.unitInCtnQty"
        />
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format, add } from '@/libs/util.number.js'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[2] = this.$l('INDEX.total') || '合计'
      return [result]
    },
    tableColumns() {
      return tableColumns(this)
    },
  },
}
</script>
